import axios from 'axios'
import app from '@/main'
import store from "@/store";

let instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  timeout: 60*1000,
  headers: {
    'Content-Type': 'application/json',
  }
})

let token = localStorage.getItem('user-token')
let apiKey = localStorage.getItem('api-key')

if (token) {
	instance.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
if (apiKey) {
	instance.defaults.headers.common['ApiKey'] = apiKey	
}

// declare a request interceptor
instance.interceptors.request.use( config => {
  // start the Progress loader
  if (app.$Progress) app.$Progress.start();

  config.headers['Accept-Language'] = store.getters['locationStore/getCurrentLanguage'];
  config.headers['channel'] = store.getters['locationStore/getChannel'];
  if(store.getters['userStore/getOneSignalPlayerId']){
    config.headers['playerId'] = store.getters['userStore/getOneSignalPlayerId']
  }
  if(store.getters['locationStore/getBusiness']){
    config.headers['Business-Id'] = store.getters['locationStore/getBusiness'].id
  }

  return config
}, error => {
  // handle the error
  return Promise.reject(error)
})

// declare a response interceptor
instance.interceptors.response.use( response => {
  // stop the Progress loader
  if (app.$Progress) app.$Progress.finish();

  return response
}, error => {
  // stop the Progress loader
  if (app.$Progress) app.$Progress.finish();
  // handle the response error
  return Promise.reject(error)
})


export default instance
